/**
 * 수집 화면 버튼 모양.
 *
 * 주 버튼(`PRIMARY`)은 배경·글자색을 인라인으로 고정한다. 인라인 색은 브라우저의 기본 비활성
 * 모양을 덮으므로, `disabled`인 주 버튼이 눌리는 버튼처럼 보였다(TASK-2026-012 CR-03). 실제로
 * 비활성이면 중립색과 비활성 커서로 바꾼다. 터치 크기(44px)·글자 크기는 상태와 무관하게 같다.
 * 비활성의 의미는 색이 아니라 `disabled` 속성과 화면의 상태 문구가 전한다 —— 색은 보조다.
 */

import type { CSSProperties } from 'react';

export const BUTTON: CSSProperties = {
  minHeight: '44px',
  padding: '0 1rem',
  fontSize: '1rem',
  borderRadius: '8px',
  border: '1px solid #6B6B6B',
  background: '#FFFFFF',
  cursor: 'pointer',
};

export const PRIMARY: CSSProperties = { ...BUTTON, background: '#0072B2', color: '#FFFFFF', borderColor: '#0072B2' };

/** 비활성 주 버튼. 연한 회색 위의 짙은 회색 글자로 읽을 수는 있되 활성 파란색과 섞이지 않는다. */
const PRIMARY_DISABLED: CSSProperties = {
  ...BUTTON,
  background: '#E6E6E6',
  color: '#595959',
  borderColor: '#BDBDBD',
  cursor: 'not-allowed',
};

/** 실제 `disabled`와 같은 조건을 넘긴다. `extra`는 자리마다의 여백 등이며 색은 덮지 않는다. */
export function primaryButton(disabled: boolean, extra: CSSProperties = {}): CSSProperties {
  return disabled ? { ...extra, ...PRIMARY_DISABLED } : { ...PRIMARY, ...extra };
}

/**
 * "모르겠다 / 응답하지 않음"의 선택 상태 (TASK-2026-014).
 *
 * 답이 비어 있으면 이 버튼이 선택된 상태다. 예전에는 선택을 불투명도 0.6으로 흐리게 그려 비활성처럼
 * 보였다. 선택은 흐림이 아니라 진한 테두리·연한 배경·굵은 글자로 보이고, 의미는 `aria-pressed`가 전한다.
 * 이 버튼은 어떤 상태에서도 `disabled`가 되지 않는다.
 */
const DONT_KNOW_SELECTED: CSSProperties = {
  ...BUTTON,
  border: '2px solid #0072B2',
  background: '#E8F2FA',
  color: '#003A5D',
  fontWeight: 700,
};

export function dontKnowButton(selected: boolean): CSSProperties {
  return selected ? DONT_KNOW_SELECTED : BUTTON;
}
